
import React from 'react';
import PropTypes from 'prop-types';
import Konva from '../../../../../konva';


import { useFinetune } from '../../../hooks';
import Slider from '../../../components/common/Slider';
import Label from '../../../element/ui/core/label';
import { StyledSliderContainer } from './HSV.styled';

const DEFAULT_VALUE = {
  hue: 0,
  saturation: 0,
  value: 0,
};

const HSVOptions = ({ t }) => {
  const [finetuneProps, setFinetuneProps] = useFinetune(
    Konva.Filters.HSV,
    DEFAULT_VALUE,
  );

  const changeValue = (name, value) => {
    setFinetuneProps({
      [name]: +value,
    });
  };

  return (
    <>
      <StyledSliderContainer className="respark_hue-option-wrapper">
        <Label className="respark_hue-option-label">{t('hue')}</Label>
        <Slider
          className="respark_hue-option"
          width="100%"
          min={0}
          step={1}
          max={259}
          value={finetuneProps.hue ?? DEFAULT_VALUE.hue}
          onChange={(val) => changeValue('hue', val)}
        />
      </StyledSliderContainer>
      <StyledSliderContainer className="respark_saturation-option-wrapper">
        <Label className="respark_saturation-option-label">{t('saturation')}</Label>
        <Slider
          className="respark_saturation-option"
          width="100%"
          min={-2}
          step={0.5}
          max={10}
          value={finetuneProps.saturation ?? DEFAULT_VALUE.saturation}
          onChange={(val) => changeValue('saturation', val)}
        />
      </StyledSliderContainer>
      <StyledSliderContainer className="respark_value-option-wrapper">
        <Label className="respark_value-option-label">{t('value')}</Label>
        <Slider
          className="respark_value-option"
          width="100%"
          min={-2}
          step={0.1}
          max={2}
          value={finetuneProps.value ?? DEFAULT_VALUE.value}
          onChange={(val) => changeValue('value', val)}
        />
      </StyledSliderContainer>
    </>
  );
};

HSVOptions.propTypes = {
  t: PropTypes.func.isRequired,
};

export default HSVOptions;
